export const TAX_CONFIG = {
  ACC_RATE: 0.0175,
  ACC_MAX_INCOME: 156641,
  ACC_MAX: 2741.22,
};

export const calculateAccLevy = (taxableIncome) => {
  const cappedIncome = Math.min(taxableIncome, TAX_CONFIG.ACC_MAX_INCOME);
  const levy = cappedIncome * TAX_CONFIG.ACC_RATE;

  return Math.min(levy, TAX_CONFIG.ACC_MAX);
};
